import { api } from "../../gateways/unilabApi";

export async function postLogin(payload) {
  return await api.post("account/login", {
    email: payload.email,
    password: payload.password
  });
}
export async function postAutomaticLogin() {
  return await api.post("account/automaticLogin");
}
export async function getUserInfo() {
  return await api.get("account/getUserInfo");
}

export async function postIsAdmin() {
  return await api.post("account/isAdmin");
}
export async function postIsUnilab() {
  return await api.post("account/isUnilab");
}
export async function getRequestLoginAccess() {
  return await api.get("account/getaccess");
}

export async function postRegisterUser(payload) {
  return await api.get("account/register", {
    email: payload.email,
    password: payload.password,
    confirmPassword: payload.confirmPassword,
    fullName: payload.fullName,
    companyName: payload.companyName
  });
}
